module.exports = __webpack_public_path__ + "static/img/in-vip.b35d1fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/in-vip.png
// module id = oTV0
// module chunks = 1